import { makeStyles } from "@mui/styles";

const style = makeStyles(theme => ({
  switchLabelSmall: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(.25),
  },
}));
export default style;